module.exports = __webpack_public_path__ + "static/img/loginbg.e393ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/loginbg.png
// module id = Pnpz
// module chunks = 3